/*eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect, Switch } from 'react-router-dom';

// Projects imports

import {
  logout,
  rolesList,
  updateUserRolesAndClaims,
  hydrateUserDataStorage,
} from '../../redux/auth';
import { AG_BASE_URL } from '../../utils/constants';

import Admin from '../Admin';
import Dashboard from '../Dashboard';
import Tracking from '../Tracking';
import Stock from '../Stock';
import NotFound from '../NotFound';
import Scheduling from '../Scheduling';
import Receipts from '../Receipts';
import RealTime from '../Dashboard/pages/RealTime/General';
import Vehicles from '../Vehicles';
import ManifestsInTransit from '../ManifestsInTransit';
import Discharges from '../Discharges';
import RecipientTracking from '../RecipientTracking';

// Module imports

import Header from './components/Header';
import Sidebar from './components/Sidebar';
import UpdatePasswordModal from './components/UpdatePasswordModal';
import ChangePasswordModal from './components/ChangePasswordModal';

import './styles.css';
import SelectCompanyModal from '../Login/components/SelectCompanyModal';
import { USER_TYPES } from '../Admin/shared/static-options';
import Wharehouse from '../OperationalDashboard/Wharehouse';
import Distribuction from '../OperationalDashboard/Distribuction';
import OperationalDashboardVehicles from '../OperationalDashboard/Vehicles';
import { filtersClear } from '../../redux/tracking';
import Modal from '../../components/Modal';
import { CancelButton, CarbonCreditModal, CarbonCreditModalButtons, CarbonCreditModalText, DefaultButton, ItemContainer, LineItemsSecondary, Title, Value } from './styles';
import { DownloadRounded } from '@mui/icons-material';
import CarbonEmissions from '../CarbonEmissions';
import NotesConnection from '../NotesConnection';

// Utils

const _hasRole = (role, userRoles) => userRoles.indexOf(role) !== -1;

const _rolesToHomePath = userRoles => {
  // if (_hasRole(rolesList.ADMINISTRATOR, userRoles) || _hasRole(rolesList.ADMIN_CUSTOMER, userRoles)) {
  //   return '/admin';
  // }

  if (
    _hasRole(rolesList.DASHBOARD, userRoles) ||
    _hasRole(rolesList.NUFARM, userRoles)
  ) {
    return '/dashboard';
  }

  if (
    _hasRole(rolesList.ADMINISTRATOR, userRoles) ||
    _hasRole(
      rolesList.ADMIN_CUSTOMER,
      userRoles,
    ) /* || _hasRole(rolesList.DASHBOARD_DISCHARGES, userRoles) */
  ) {
    return '/baixas';
  }

  if (_hasRole(rolesList.TRAVEL_MONITORING, userRoles)) {
    return '/travel-monitoring';
  }

  if (_hasRole(rolesList.MANIFESTS_IN_TRANSIT, userRoles)) {
    return '/manifests-in-transit';
  }

  if (_hasRole(rolesList.VEHICLES, userRoles)) {
    return '/vehicles';
  }

  if (_hasRole(rolesList.TRACKING, userRoles)) {
    return '/tracking';
  }

  if (_hasRole(rolesList.STOCK, userRoles)) {
    return '/estoque/atual';
  }

  if (_hasRole(rolesList.DASHBOARD_DISCHARGES, userRoles)) {
    return '/baixas';
  }

  return '/404';
};

// Component

class Logged extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSidebarVisible: false,
      isSelectCompanyModalIsVisible: false,
      isChangePasswordVisible: false,
      selectCompanyModalListIsVisible: false,
      showCertificateModal: false,
      showCarbonCreditModal: false,
    };
  }

  componentWillMount() {
    this.props.dispatch(hydrateUserDataStorage());
  }

  componentDidMount() {
    this.props.dispatch(updateUserRolesAndClaims());
  }

  componentWillReceiveProps(nextProps) {
    const { activeCompany, userType } = nextProps;

    // Devido à indisponibilidade do serviço de integração, o fluxo de login
    // automático no Armazém Geral foi desativado. O usuário é redirecionado
    // para a tela de login do AG em vez de ser autenticado automaticamente
    // e enviado para dentro da aplicação.
    //
    // Integration token
    // ===========================
    // if (
    //   this.props.integrationToken !== integrationToken &&
    //   !integrationTokenUi.isFetching &&
    //   !integrationTokenUi.error
    // ) {
    //   this._openIntegrationTab(integrationToken);
    // }
    //
    // if (integrationTokenUi.error) {
    //   console.log(
    //     'Ocorreu um erro durante a autenticação no Armazém Geral. Por favor, tente novamente.',
    //   );
    // }

    // missing companyId + name on localStorage
    // ============================================
    if (
      (!activeCompany.id || !activeCompany.name) &&
      userType === USER_TYPES.CUSTOMER_SERVICE_USER &&
      !this.state.isSelectCompanyModalIsVisible
    ) {
      this._toggleCompanySelectModal();
    }
  }

  _toggleSidebar = () => {
    this.setState({ isSidebarVisible: !this.state.isSidebarVisible });
    this.props.dispatch(updateUserRolesAndClaims());
  };

  _navigate = path => {
    if (path !== this.props.location.pathname) {
      this._toggleSidebar();
    }
  };

  _logout = () => {
    const { dispatch, history } = this.props;

    dispatch(logout());
    dispatch(filtersClear());
    history.push('/');
  };

  _hideChangePasswordModal = () => {
    this.setState({ isChangePasswordVisible: false });
  };

  _changePassword = () => {
    this._toggleSidebar();
    this.setState({ isChangePasswordVisible: true });
  };

  _getIntegrationToken = () => {
    // Devido à indisponibilidade do serviço de integração, o usuário é
    // redirecionado para a tela de login do Armazém Geral em vez de ser
    // autenticado automaticamente e enviado para dentro da aplicação.
    window.open(AG_BASE_URL);

    // this.props.dispatch(getIntegrationToken());
  };

  _openIntegrationTab = () => {
    // Desativado — integração por token indisponível.
    // window.open(`${AG_BASE_URL}?tokenAcesso=${integrationToken}`);
  };

  _toggleCompanySelectModal = () => {
    this.setState({
      isSelectCompanyModalIsVisible: !this.state.isSelectCompanyModalIsVisible,
    });
  };

  _onCompanySelect = () => {
    const { history } = this.props;

    this._toggleCompanySelectModal();
    history.go(0);
  };

  _onPasswordUpdateSuccess = () => {
    const { dispatch } = this.props;

    dispatch(logout());
    console.log(
      'Senha alterada com sucesso! Por favor, faça seu login novamente.',
    );
  };

  _toggleSelectCompanyModalList = () => {
    this.setState({
      selectCompanyModalListIsVisible: !this.state.selectCompanyModalListIsVisible,
    });
  };

  _toggleShowCertificateModal = (disableCertificateButton) => {
    if (!disableCertificateButton) {
      this.setState({
        showCertificateModal: !this.state.showCertificateModal,
      });
    }
  };

  _toggleShowCarbonCreditModal = () => {
    this.setState({
      showCarbonCreditModal: !this.state.showCarbonCreditModal,
    });
  };

  _carbonCreditTab = () => {
    this._toggleShowCarbonCreditModal();
    window.open('https://viagreen.org.br/compensacao-de-carbono/');
  }

  render() {
    const {
      match,
      location,
      accessToken,
      roles,
      userType,
      activeCompany,
      sidebar,
      header,
      operationalDashboard,
      companyData,
    } = this.props;

    const { isSidebarVisible, isChangePasswordVisible } = this.state;
    
    const { registration, description, certificateUrl } = companyData;
    
    const isAdmin = _hasRole(rolesList.ADMINISTRATOR, roles);
    if (accessToken) {
      return (
        <div className="Logged">
          {sidebar && (
            <Sidebar
              isVisible={isSidebarVisible}
              onBackdropClick={this._toggleSidebar}
              onLogout={this._logout}
              onChangePassword={this._changePassword}
              onNavigate={this._navigate}
              onIntegrationTokenRequest={this._getIntegrationToken}
              integrationTokenIsFetching={false}
              roles={roles}
              activeCompany={activeCompany}
              userType={userType}
              onCompanySelect={this._toggleCompanySelectModal}
            />
          )}
          {header && (
            <Header
              operationalDashboard={operationalDashboard}
              isSidebarActive={isSidebarVisible}
              onMenuClick={this._toggleSidebar}
              userType={userType}
              activeCompany={activeCompany}
              onCompanySelect={this._toggleCompanySelectModal}
            />
          )}
          <Switch>
            <Redirect
              exact
              path={match.url}
              to={`${match.url}${_rolesToHomePath(roles)}`}
            />
            {(isAdmin ||
              _hasRole(rolesList.DASHBOARD, roles) ||
              _hasRole(rolesList.NUFARM, roles)) && (
                <Route path={`${match.url}/dashboard`} component={Dashboard} />
              )}
            {(isAdmin ||
              _hasRole(rolesList.TRAVEL_MONITORING, roles) ||
              _hasRole(rolesList.NUFARM, roles)) && (
                <Route
                  path={`${match.url}/travel-monitoring`}
                  component={RealTime}
                />
              )}
            {(isAdmin ||
              _hasRole(rolesList.VEHICLES, roles) ||
              _hasRole(rolesList.NUFARM, roles)) && (
                <Route path={`${match.url}/vehicles`} component={Vehicles} />
              )}
            {(isAdmin ||
              _hasRole(rolesList.VEHICLES, roles) ||
              _hasRole(rolesList.NUFARM, roles)) && (
                <Route
                  path={`${match.url}/manifests-in-transit`}
                  component={ManifestsInTransit}
                />
              )}
            {(isAdmin || _hasRole(rolesList.TRACKING, roles)) && (
              <Route path={`${match.url}/tracking/:id`} component={Tracking} />
            )}
            {(isAdmin || _hasRole(rolesList.TRACKING, roles)) && (
              <Route path={`${match.url}/tracking`} component={Tracking} />
            )}
            {(isAdmin || _hasRole(rolesList.RECIPIENT_TRACKING, roles)) && (
              <Route
                path={`${match.url}/recipient-tracking`}
                component={RecipientTracking}
              />
            )}
            {(isAdmin || _hasRole(rolesList.ADMIN_CUSTOMER, roles)) && (
              <Route path={`${match.url}/admin`} component={Admin} />
            )}
            {(isAdmin || _hasRole(rolesList.STOCK, roles)) && (
              <Route path={`${match.url}/estoque`} component={Stock} />
            )}
            {(isAdmin || _hasRole(rolesList.SCHEDULING, roles)) && (
              <Route path={`${match.url}/agendamento`} component={Scheduling} />
            )}
            {(isAdmin || _hasRole(rolesList.OPERATIONS, roles)) && (
              <Route path={`${match.url}/deposito`} component={Wharehouse} />
            )}
            {(isAdmin || _hasRole(rolesList.OPERATIONS, roles)) && (
              <Route
                path={`${match.url}/distribuicao`}
                component={Distribuction}
              />
            )}
            {(isAdmin || _hasRole(rolesList.OPERATIONS, roles)) && (
              <Route
                path={`${match.url}/veiculos`}
                component={OperationalDashboardVehicles}
              />
            )}
            {isAdmin && (
              <Route path={`${match.url}/comprovantes`} component={Receipts} />
            )}
            {(isAdmin || _hasRole(rolesList.DASHBOARD_DISCHARGES, roles)) && (
              <Route path={`${match.url}/baixas`} component={Discharges} />
            )}
            {(isAdmin || _hasRole(rolesList.CARBON_EMISSIONS, roles)) && (
              <Route path={`${match.url}/emissoes-co2`} component={CarbonEmissions} />
            )}
            {_hasRole(rolesList.NOTES_CONNECTION, roles) && (
              <Route path={`${match.url}/conexao-notas`} component={NotesConnection} />
            )}
            <Route component={NotFound} />
          </Switch>

          <UpdatePasswordModal
            onUpdateSuccess={this._onPasswordUpdateSuccess}
          />

          {isChangePasswordVisible && (
            <ChangePasswordModal
              onBackdropClick={this._hideChangePasswordModal}
              onSuccess={this._hideChangePasswordModal}
            />
          )}

          {this.state.isSelectCompanyModalIsVisible && (
            <SelectCompanyModal
              onCompanySelect={this._onCompanySelect}
              onToggleCompanySelectModal={this._toggleCompanySelectModal}
              onToggleSelectCompanyModalList={this._toggleSelectCompanyModalList}
              selectCompanyModalListIsVisible={this.state.selectCompanyModalListIsVisible}
              onToggleShowCertificateModal={this._toggleShowCertificateModal}
              onToggleShowCarbonCreditModal={this._toggleShowCarbonCreditModal}
              showPopover={true}
            />
          )}

          {this.state.showCertificateModal && (
            <div>
              <Modal
                title="Meu Certificado de Neutralização"
                size="large"
                hasClose
                onBackdropClick={() => this._toggleShowCertificateModal(false)}
                secondaryHeader
              >
                <div>
                  <img src={certificateUrl} style={{ width: '100%' }} alt='Certificado' />
                  <LineItemsSecondary>
                    <ItemContainer>
                      <Title>Registro</Title>
                      <Value>{registration}</Value>
                    </ItemContainer>
                    <ItemContainer>
                      <Title>Descrição</Title>
                      <Value>{description}</Value>
                    </ItemContainer>
                    <ItemContainer>
                      <Title>Certificado</Title>
                      <Value>
                        <DefaultButton>
                          <DownloadRounded />
                          Baixar Certificado
                        </DefaultButton>
                      </Value>
                    </ItemContainer>
                  </LineItemsSecondary>
                </div>
              </Modal>
            </div>
          )}

          {this.state.showCarbonCreditModal && (
            <Modal
              title="Utilizar crédito de carbono"
              size="large"
              hasClose
              onBackdropClick={this._toggleShowCarbonCreditModal}
              secondaryHeader
            >
              <CarbonCreditModal>
                <CarbonCreditModalText>
                  Atenção! Para utilizar seu crédito de carbono, você será redirecionado para uma página externa de compensação de carbono. Tem certeza de que deseja prosseguir?
                </CarbonCreditModalText>

                <CarbonCreditModalButtons>
                  <CancelButton onClick={this._toggleShowCarbonCreditModal}>
                    Cancelar
                  </CancelButton>
                  <DefaultButton onClick={this._carbonCreditTab}>
                    Continuar
                  </DefaultButton>
                </CarbonCreditModalButtons>
              </CarbonCreditModal>
            </Modal>
          )}
        </div>
      );
    }

    return (
      <Redirect
        to={{
          pathname: '/',
          state: { from: location },
        }}
      />
    );
  }
}

// Redux

const mapStateToProps = state => ({
  accessToken: state.auth.accessToken,
  roles: state.auth.roles,
  // integrationToken: state.auth.integrationToken.token,
  // integrationTokenUi: getIntegrationTokenUI(state),
  activeCompany: {
    id: state.auth.activeCompanyId,
    name: state.auth.activeCompanyName,
  },
  userType: state.auth.userType,
  companyData: state.auth.companyData,
});

Logged.defaultProps = {
  header: true,
  sidebar: true,
};

export default connect(mapStateToProps)(Logged);
